import * as React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { FullscreenMode } from '~src/fullscreen-internals/fullscreen-mode';
import { SwanLogo } from '~src/icons/swan-logo';
import { colors } from '~src/theme/colors';

import { SwanLabelModal } from './swan-label-modal';

interface SwanLabelComponentProps {
  selected: boolean;
}

/**
 * Translations for swan label are fixed - https://www.svanen.se/4983a5/siteassets/for-licensinnehavare/marketing-guidelines/nordic_swan_ecolabel_guidelines_ecommerce_april_2023.pdf
 */
export const SwanLabelComponent: React.FC<SwanLabelComponentProps> = ({ selected }) => {
  const { tICU } = useTranslations();
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);

  return (
    <>
      <div
        css={{ display: 'flex', cursor: selected ? 'pointer' : 'unset' }}
        onClick={selected ? () => setModalOpen(true) : undefined}
        role="presentation"
      >
        <SwanLogo />
        <span css={{ color: colors.green, marginLeft: '4px' }}>
          {tICU('widget.LABEL_MODAL.SWAN.TITLE')}
        </span>
      </div>
      {modalOpen && (
        <FullscreenMode>
          <SwanLabelModal onClose={() => setModalOpen(false)} />
        </FullscreenMode>
      )}
    </>
  );
};
